import axios from 'axios';
import { getToken, getTokenHeader } from '../../../../../screen/auth/action';
import { ShopInsurancesInfoUrl, ShopInsurancesUrl } from '../url';

export const getShopInsuranceDetailAction  = async (company_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${ShopInsurancesUrl()}?company_esi_id=${company_esi_id}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getShopInsuranceInfoAction  = async (company_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${ShopInsurancesInfoUrl()}?company_esi_id=${company_esi_id} `, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};



export const AddShopInsuranceAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        `${ShopInsurancesUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const updateShopInsuranceAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .patch(ShopInsurancesUrl(), data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};